(function initPinnedVerticalGalleries() {
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
    console.warn('[PinnedGallery] GSAP/ScrollTrigger not loaded.');
    return;
  }
  gsap.registerPlugin(ScrollTrigger);

  const headerEl = document.getElementById('header');
  const headerOffset = headerEl ? headerEl.offsetHeight : 0;
  const sections = document.querySelectorAll('.fv-layout__wrapper.fv-section--project-cards');
  if (!sections.length) return;

  sections.forEach((section, sIdx) => {
    const rightInner = section.querySelector('.pv__right-inner');
    const track = section.querySelector('.pv__track');
    const cards = gsap.utils.toArray(section.querySelectorAll('.pv-card'));
    const items = gsap.utils.toArray(section.querySelectorAll('.pv__item'));
    if (!rightInner || !track || !cards.length || !items.length) return;

    // pin da lateral (desktop)
    const mm = gsap.matchMedia();
    mm.add('(min-width: 901px)', () => {
      ScrollTrigger.create({
        trigger: rightInner,
        start: `top+=-${headerOffset} top`,
        end: () => '+=' + Math.max(0, track.scrollHeight - rightInner.clientHeight - headerOffset),
        pin: true,
        pinSpacing: false,
        anticipatePin: 1,
        id: `pin-${sIdx}`,
        // markers: true,
      });
    });

    // helper para .active na lista
    const setActive = (i) => items.forEach((b, idx) => b.classList.toggle('active', idx === i));

    // for each card: 3D roll (no fade)
    cards.forEach((card, i) => {
      // “ativo” quando o centro do card cruza o centro da viewport
      ScrollTrigger.create({
        trigger: card,
        start: 'top center',
        end: 'bottom center',
        onEnter: () => setActive(i),
        onEnterBack: () => setActive(i),
        // markers: true,
      });

      // roll: mapeia a distância do centro do card ao centro da viewport
      ScrollTrigger.create({
        trigger: card,
        start: 'top bottom', // começa a calcular quando entra na tela
        end: 'bottom top', // até sair
        scrub: true,
        // markers: true,
      });
    });

    // clique na lista → scroll até o card
    items.forEach((btn) => {
      btn.addEventListener('click', () => {
        const idx = parseInt(btn.getAttribute('data-target'), 10);
        const target = cards[idx];
        if (!target) return;
        const top = target.getBoundingClientRect().top + window.scrollY - headerOffset;
        window.scrollTo({ top, behavior: 'smooth' });
      });
    });

    var _refreshTimer;
    window.addEventListener('resize', function () {
      clearTimeout(_refreshTimer);
      _refreshTimer = setTimeout(function () { ScrollTrigger.refresh(); }, 200);
    }, { passive: true });
    window.addEventListener('load', function () { ScrollTrigger.refresh(); });
  });
})();
